import styled from 'styled-components';
import { CameraSwitchIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/base-components';
import { useCallerVideoContext } from '../CallerVideoContext/useCallerVideoContext';
import { ControlButton } from './ControlButton/ControlButton';

const StyledButton = styled(Button)`
  height: 47px;
  padding: 11.5px 14px;
  border-radius: 10px;
  border: none;
`;

export const FlipCameraButton = () => {
  const { toggleFacingMode } = useCallerVideoContext();

  return (
    <ControlButton buttonBackground="white" text="Flip">
      <StyledButton
        onClick={toggleFacingMode}
        btnType="secondary"
        noMargin={true}
        grow={false}
      >
        <CameraSwitchIcon width={24} height={24} color="black" />
      </StyledButton>
    </ControlButton>
  );
};
